import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import CryptoSelectTransfer from "./CryptoSelectTransfer.js";
import TransferResume from "./TransferResume.js";
import { useParams } from "react-router";

const TransferToAgent = ({ token, id }) => {
	const params = useParams();
	const [step, setStep] = useState(1);
	const { crypto, net } = params;
	const [cryptoCurrency, setCryptoCurrency] = useState(crypto ?? null);
	const [network, setNetwork] = useState(net ?? null);
	const [address, setAddress] = useState(null);
	const [agent, setAgent] = useState(null);
	const [agreement, setAgreement] = useState(false);
	const [transfer, setTransfer] = useState(null);

	if (step === 1) {
		return (
			<Grid container sx={{ justifyContent: "center", alignContent: "center", textAlign: "center" }}>
				<CryptoSelectTransfer
					title={"Transfer Crypto"}
					setCryptoCurrency={setCryptoCurrency}
					cryptoCurrency={cryptoCurrency}
					network={network}
					setNetwork={setNetwork}
					setStep={setStep}
					token={token}
					agent={agent}
					setAgent={setAgent}
					setTransfer={setTransfer}
				/>
			</Grid>
		);
	}

	if (step === 2) {
		return (
			<Grid container sx={{ justifyContent: "center", alignContent: "center", textAlign: "center" }}>
				<TransferResume transfer={transfer} />
			</Grid>
		);
	}
};

export default TransferToAgent;
